module.exports = __webpack_public_path__ + "img/无影美妆灯.11a439f1.webp";